/* eslint-disable react/jsx-props-no-spreading */
import { SvgIcon } from '@mui/material'
import { React } from 'react'

function BillExplorerIcon(props) {
  return (
    <SvgIcon {...props} stroke="currentColor" strokeWidth="2">
      <path fill="none" strokeLinecap="round" strokeLinejoin="round" d="M15.75 15.75l-2.489-2.489m0 0a3.375 3.375 0 10-4.773-4.773 3.375 3.375 0 004.774 4.774zM21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
    </SvgIcon>
  )
}

export default BillExplorerIcon
